import './causesItems.scss';

import React from 'react';
import cx from 'classnames';
import Definition from '../definition/definition';
import IconItem from '../iconItem';

import iconAgeRed from '../../images/icon-age-red.svg';
import iconAge from '../../images/icon-age.svg';
import iconSmokingRed from '../../images/icon-smoking-red.svg';
import iconSmoking from '../../images/icon-smoking.svg';
import iconChemicalsRed from '../../images/icon-chemicals-red.svg';
import iconChemicals from '../../images/icon-chemicals.svg';
import iconHistoryRed from '../../images/icon-medical-records-red.svg';
import iconHistory from '../../images/icon-medical-records.svg';
import tw, { css } from 'twin.macro';

const CausesItems = ({ styleName = '', colorIcons = true }) => {
  return (
    <div className={cx('causes__items', styleName)}>
      <IconItem
        colorIcon={colorIcons}
        key="icon-item--age"
        id={colorIcons ? 'age-red' : 'age'}
        icon={colorIcons ? iconAgeRed : iconAge}
        iconAlt="70+ icon"
        title="Age"
        description="Most people diagnosed with UTUC are between 70 and 90 years old"
        css={
          !colorIcons &&
          css`
            .icon-item__img {
              width: 200px !important;
            }
          `
        }
      />
      <IconItem
        colorIcon={colorIcons}
        key="icon-item--smoking"
        id="smoking"
        icon={colorIcons ? iconSmokingRed : iconSmoking}
        iconAlt="Smoking icon"
        title="Smoking"
        description="Increases your risk of any cancer, including UTUC"
      />
      <IconItem
        colorIcon={colorIcons}
        key="icon-item--chemicals"
        id="chemicals"
        icon={colorIcons ? iconChemicalsRed : iconChemicals}
        iconAlt="Beaker with fluid icon"
        title="Exposure to chemicals"
        description="This may be associated with certain jobs as well as consuming aristolochic acid (found in a medicinal Chinese herb)"
      />
      <IconItem
        colorIcon={colorIcons}
        key="icon-item--history"
        id="history"
        icon={colorIcons ? iconHistoryRed : iconHistory}
        iconAlt="Medical chart icon"
        title="Medical history"
      >
        Having other types of cancer in the past or an inherited syndrome like{' '}
        <Definition term="Lynch syndrome" id="lynch_syndrome" />
      </IconItem>
    </div>
  );
};

export default CausesItems;
